module.exports = __webpack_public_path__ + "img/icon_img41.450bf46d.png";